import { RouterQuery } from './router-query-filters';

export const NO_PRODUCT_AREA_OPTION_ID = '';

export const NO_PRODUCT_AREA_AGG_ID = 'noProductArea';

const QUERY_SEPARATOR = ',';

export type DashboardGroups = string[];

const toSentinel = (id: string): string => (id === NO_PRODUCT_AREA_OPTION_ID ? NO_PRODUCT_AREA_AGG_ID : id);
const fromSentinel = (id: string): string => (id === NO_PRODUCT_AREA_AGG_ID ? NO_PRODUCT_AREA_OPTION_ID : id);

const toIdList = (groups?: DashboardGroups): string[] =>
    (Array.isArray(groups) ? groups : []).filter((id) => typeof id === 'string');

export const formatGroupsForQuery = (groups: DashboardGroups) => {
    const ids = toIdList(groups).map(toSentinel);

    if (!ids.length) return { groups: undefined };

    return { groups: ids.join(QUERY_SEPARATOR) };
};

export const convertQueryToGroups = ({ groups }: RouterQuery) => {
    if (typeof groups !== 'string' || !groups) return {};

    const ids = Array.from(
        new Set(
            groups
                .split(QUERY_SEPARATOR)
                .map((id) => id.trim())
                .filter((id) => id.length > 0)
                .map(fromSentinel),
        ),
    );

    if (!ids.length) return {};

    return { groups: ids };
};

export const toAggGroups = (groups?: DashboardGroups): string[] => toIdList(groups).map(toSentinel);

export const isNoProductAreaId = (id: unknown): boolean =>
    id === NO_PRODUCT_AREA_OPTION_ID || id === NO_PRODUCT_AREA_AGG_ID;

export const normalizeGroupIds = (groups?: DashboardGroups): string[] =>
    Array.from(new Set(toIdList(groups).map(fromSentinel)));

export const reconcileGroups = (groups: DashboardGroups, availableIds: string[]): DashboardGroups => {
    const available = new Set([...availableIds, NO_PRODUCT_AREA_OPTION_ID]);

    return toIdList(groups).filter((id) => available.has(id));
};
